import { render, staticRenderFns } from "./FairDuels.vue?vue&type=template&id=c8ca244c&scoped=true"
import script from "./FairDuels.vue?vue&type=script&lang=js"
export * from "./FairDuels.vue?vue&type=script&lang=js"
import style0 from "./FairDuels.vue?vue&type=style&index=0&id=c8ca244c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ca244c",
  null
  
)

export default component.exports